var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Actions from '../actions';
export var updateIdentity = function (state, action) {
    return __assign(__assign({}, state), { identity: action.payload });
};
export var updateRecipientId = function (state, action) {
    return __assign(__assign({}, state), { recipientIdentity: action.payload });
};
export var updateMembers = function (state, action) {
    return __assign(__assign({}, state), { members: action.payload });
};
export var updateTyping = function (state, action) {
    var type = action.type, memberId = action.payload;
    var members = state.members;
    var memberIndex = members.findIndex(function (m) { return m.identity === memberId; });
    if (memberIndex !== -1)
        members[memberIndex].isTyping = type === Actions.Types.TYPING_STARTED;
    return __assign(__assign({}, state), { members: members });
};
//# sourceMappingURL=MemberReducers.js.map